import { Controller } from '@hotwired/stimulus';
import Splide from '../splide';

export default class extends Controller {
  static targets = ['slider'];

  connect() {
    const slider = new Splide(this.sliderTarget).mount();

    this.element.querySelectorAll('.splide__slide').forEach(slide => {
      slide.addEventListener('mouseenter', () => {
        this.element.style.setProperty('--background-image', `url("${slide.dataset.background}")`);
      });
    });
  }
}
